<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input size="medium" v-model="searchForm.name" placeholder="请输入优惠券名称"  @keyup.enter.native="getTableList"></el-input>
      <el-select
        size="medium"
        v-model="searchForm.status"
        placeholder="请选择状态"
        @change="getTableList"
        clearable 
      >
        <el-option
          v-for="item in pollList"
          :key="item.key"
          :label="item.label"
          :value="item.key"
        ></el-option>
      </el-select>
      <!-- <el-input size="medium" v-model="searchForm.key_words" placeholder="请输入搜索内容"  @keyup.enter.native="getTableList"></el-input> -->
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <!-- <el-table-column
      width="160"
      label="充币时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.doneTime)}}</span>
      </template>
    </el-table-column> -->
      <el-table-column
        type="index"
        width="60px"
        label="序号">
      </el-table-column>
      <el-table-column
        prop="name"
        width="120"
        label="优惠券名称">
      </el-table-column>
      <el-table-column
        prop="type"
        label="类型">
        <template slot-scope="scope">
          <span>{{scope.row.type?'抵扣': '--'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="160"
        prop="createTime"
        label="创建时间">
      </el-table-column>
      <el-table-column prop="" label="领取时间" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.release.releaseStartDate+'至'+scope.row.release.releaseEndDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="有效时间" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.release.useDateType==1">{{scope.row.release.useStartDate?scope.row.release.useStartDate+'至'+scope.row.release.useEndDate:null}}</span>
          <span v-else>{{scope.row.release.useDay}} 天</span>
        </template>
      </el-table-column>
      <el-table-column
        width="110"
        prop="nodePower"
        label="发放数量(张)">
        <template slot-scope="scope">
          <span>{{scope.row.release.num}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        width="110"
        label="领取数量(张)">
        <template slot-scope="scope">
          <span>{{scope.row.release.releaseNum}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="剩余数量(张)" width="110">
        <template slot-scope="scope">
          <span>{{scope.row.release.liftNum}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="使用数量(张)" width="110">
        <template slot-scope="scope">
          <span>{{scope.row.release.useNum}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="gas" label="状态">
        <template slot-scope="scope">
          <span>{{scope.row.release.status==0?'待审核':scope.row.release.status==1?'审核中':scope.row.release.status==2?'审核拒绝':scope.row.release.status==3?'待发放':scope.row.release.status==4?'发放中':scope.row.release.status==5?'已过期':scope.row.release.status==6?'已暂停':scope.row.release.status==7?'已终止':'发放完毕'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" label="提交人" width="100"> </el-table-column>
      <el-table-column prop="checkBy" label="审批人" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.release.checkBy}}</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        width="260px"
        label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="goDetl(scope.row)"><i class="el-icon-view" style="margin-right:3px;"></i>查看</el-button>
          <el-button size="mini" type="primary" @click="goSubmint(scope.row.id,1)" v-if="scope.row.release.status==6"><i class="el-icon-setting" style="margin-right:3px;"></i>继续发放</el-button>
          <el-button size="mini" type="danger" @click="goSubmint(scope.row.id,0)"  v-if="scope.row.release.status==4"><i class="el-icon-setting" style="margin-right:3px;"></i>暂停发放</el-button>
          <el-button size="mini" type="danger" @click="goSubmint(scope.row.id,2)"  v-if="scope.row.release.status==3||scope.row.release.status==4||scope.row.release.status==6"><i class="el-icon-setting" style="margin-right:3px;"></i>终止发放</el-button>
          <el-button size="mini" type="warning" @click="changeStust(scope.row,0)" v-if="scope.row.release.status==1"><i class="el-icon-setting" style="margin-right:3px;"></i>同意</el-button>
          <el-button size="mini" type="danger" @click="changeStust(scope.row,1)" v-if="scope.row.release.status==1"><i class="el-icon-setting" style="margin-right:3px;"></i>拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="1000px">
      <div class="data_box" v-if="dataObj">
        <div class="title_box">
          <div>优惠券中文名：{{dataObj.name}}</div>
          <div>优惠券英文名：{{dataObj.nameEn}}</div>
          <div>优惠券类型：抵扣金额</div>
          <div>适用范围：{{dataObj.limitProduct?'指定商品':'全场通用'}}</div>
        </div>
        <div class="info_box">
          <div class="small_box">
            <div style="width:240px">创建时间：{{dataObj.createTime}}</div>
            <div>优惠券面值：{{dataObj.discountUsdt + 'USDT'}}</div>
            <div>发放数量：{{dataObj.release.num + '张'}}</div>
            <div>黑名单区域：{{dataObj.areaCodes}}</div>
          </div>
          <div class="small_box">
            <div style="width:240px">发放时间：{{dataObj.createTime}}</div>
            <div>每人限领数量：{{dataObj.release.limitNum + '张'}}</div>
            <div>领取数量：{{dataObj.release.releaseNum + '张'}}</div>
            <div>是否只限新用户领取：{{dataObj.release.onlyNewUser?'是':'否'}}</div>
          </div>
          <div class="small_box">
            <div style="width:240px">有效时间：{{dataObj.release.releaseStartDate+'-' +dataObj.release.releaseEndDate}}</div>
            <el-tooltip class="item" effect="dark" :content="dataObj.productIds" placement="bottom">
              <div>指定商品：{{dataObj.limitProduct?dataObj.productIds:null}}</div>
            </el-tooltip>
            <div>剩余数量：{{dataObj.release.liftNum + '张'}}</div>
            <div style="opacity: 0;">是否只限新用户领取：{{dataObj.release.onlyNewUser?'是':'否'}}</div>
          </div>
          <div class="small_box">
            <div style="width:240px">状态：{{dataObj.release.status==0?'待提交':dataObj.release.status==1?'审核中':dataObj.release.status==2?'审核拒绝':dataObj.release.status==3?'待发放':dataObj.release.status==4?'发放中':dataObj.release.status==5?'已过期':dataObj.release.status==6?'已暂停':dataObj.release.status==7?'已终止':'发放完毕'}}</div>
            <div>抵扣条件：{{dataObj.minPower+'TiB'}}</div>
            <div>使用数量：{{dataObj.release.useNum + '张'}}</div>
            <div style="opacity: 0;">是否只限新用户领取：{{dataObj.release.onlyNewUser?'是':'否'}}</div>
          </div>
        </div>
        <div class="ms_box" v-if="dataObj.description">
          <div class="title">优惠券描述(中文)：</div>
          <div class="ms_box_rg" v-html="dataObj.description"></div>
        </div>
        <div class="ms_box" v-if="dataObj.descriptionEn">
          <div class="title">优惠券描述(英文)：</div>
          <div class="ms_box_rg" v-html="dataObj.descriptionEn"></div>
        </div>
        <div class="pz_box">
          <div>提交人：{{dataObj.createBy}}</div>
          <div>审批人：{{dataObj.release.checkBy}}</div>
          <div>审批备注：{{dataObj.release.checkMemo}}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        name: null,
        status: null,
        isCheckList: true
      },
      tableData: [],
      pollList: [
        {key:'',label:'全部'},
        {key:'1',label:'审核中'},
        {key:'2',label:'审核拒绝'},
        {key:'3',label:'待发放'},
        {key:'4',label:'发放中'},
        {key:'5',label:'已过期'},
        {key:'6',label:'已暂停'},
        {key:'7',label:'已终止'},
        {key:'8',label:'发放完毕'},
      ],
      dialogVisible: false,
      nodeTableList:[],
      dataObj:null
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    changeStust(row,type) {
      let txt 
      if (type==0) {
        txt = '审核通过 备注原因（可选填）'
      } else {
        txt= '审核拒绝 备注原因（可选填)'
      }
      this.$prompt(txt, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async({ value }) => {
        console.log(value)
        let res = await this.$http.couponCheck({id:row.id,operate:type,checkMemo:value})
        if (res) {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.getTableList()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消操作'
        });       
      });
    },
    addFunc(type,id){
      if(type=='add'){
        this.$router.push({name:'addEidt'})
      } else {
        this.$router.push({name:'copyAdd',query:{id:id}})
      }
    },
    goSubmint(id,type){
      let msg
      if (type==0) {
        msg = '此操作将暂停该优惠券的发放, 是否继续?'
      } else if(type==1){
        msg = '此操作将继续该优惠券的发放, 是否继续?'
      } else {
        msg = '此操作将终止该优惠券的发放, 是否继续?'
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await this.$http.stopOrContinueRelease({id:id,operate:type});
        if (res) {
          this.getTableList()
          this.$message({
            type: 'success',
            message: '提交成功!'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });          
      });
    },
    async goDetl(item) {
      this.dataObj = item
      this.dialogVisible = true
      
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.couponPage({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
.title_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.info_box{
  margin: 20px 0;
  height: 150px;
  background: #eee;
  border-radius: 10px;
  padding: 20px;
}
.small_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.small_box div{
  width: 160px;
  white-space:nowrap;/* 规定文本是否折行 */  
  overflow: hidden;/* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
}
.ms_box{
  display: flex;
  background: #eee;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
  color: #666;
}
.title{
  color: #333;
}
.pz_box{
  display: flex;
  align-items: center;
}
.pz_box div{
  margin-right: 40px;
}
</style>
